import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  UserCertification,
  getUserCertification as universalGetUserCertification,
} from './academy-certifications-v1-user-certification-user-certifications.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/user-certifications' };

export function getUserCertification(
  httpClient: HttpClient
): GetUserCertificationSignature {
  return (userCertificationId: string) =>
    universalGetUserCertification(
      userCertificationId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetUserCertificationSignature {
  /**
   * Retrieves a user certification.
   * @param - ID of the user certification to retrieve.
   * @returns Retrieved user certification.
   */
  (userCertificationId: string): Promise<
    NonNullablePaths<UserCertification, `certificationType`, 2>
  >;
}

export {
  AccountInfo,
  ActionEvent,
  CertificationType,
  CreateUserCertificationRequest,
  CreateUserCertificationResponse,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Cursors,
  DeleteUserCertificationRequest,
  DeleteUserCertificationResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetUserCertificationRequest,
  GetUserCertificationResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  QueryUserCertificationsRequest,
  QueryUserCertificationsResponse,
  RestoreInfo,
  SortOrder,
  Sorting,
  UserCertification,
  WebhookIdentityType,
} from './academy-certifications-v1-user-certification-user-certifications.universal.js';
